"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGiveawayProduct = void 0;
function mockGiveawayProduct(overrides = {}) {
    return {
        after_entry_content: null,
        ambassadors: [],
        brands: [],
        description: 'mock description',
        end_date: '2022-05-04T12:55:23.000-00:00',
        complete: false,
        faq: 'mock faq',
        giveaway_type: 'giveaway',
        image: 'mock image',
        require_species: false,
        require_waterbodies: false,
        rules: 'mock rules',
        skip_signup_followup: false,
        slug: 'mock slug',
        start_date: '2022-05-03T12:55:23.000-00:00',
        title: 'mock title',
        waterbodies: [],
        video: null,
        ...overrides,
    };
}
exports.mockGiveawayProduct = mockGiveawayProduct;
